module.exports = __webpack_public_path__ + "static/img/ek.d45cc43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/ek.png
// module id = gc/c
// module chunks = 0